import type { DataTableColumnType } from '@/components/UI/DataTableV2/DataTable.model';

/**
 * The six child column types that make up a dosing session matrix.
 * Derived from DataTableColumnType so a rename in the OpenAPI spec fails to compile
 * rather than silently falling through to an unlabelled header.
 */
export type DoseColumnType = Extract<
  DataTableColumnType,
  'doseTreatment' | 'doseWeight' | 'doseVolume' | 'dosedAt' | 'doseComment' | 'doseStatus'
>;

/**
 * Eyebrow label shown above the session name on a dosing session group header.
 */
export const DOSING_SESSION_GROUP_LABEL = 'Dosing';

/**
 * Header labels for the dosing session child columns.
 *
 * These are deliberately not taken from the server's `column.name`: the API sends
 * "Weight" and "Dosed at" where the design calls for "Weight at dosing" and
 * "Dosing time". The sibling sample columns hard-code their labels for the same
 * reason (`sampleStatus` renders "Status" against a server name of "Sample status").
 */
export const DOSE_COLUMN_LABELS: Record<DoseColumnType, string> = {
  doseTreatment: 'Treatment',
  doseWeight: 'Weight at dosing',
  doseVolume: 'Volume',
  dosedAt: 'Dosing time',
  doseComment: 'Comment',
  doseStatus: 'Status',
};
